<template>
	<div class="detail detailbox">
		<Tou></Tou>
		<el-breadcrumb class="w1500 pt-30" separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/forum' }">Forum</el-breadcrumb-item>
			<el-breadcrumb-item>{{tzshu.title}}</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- <div> -->
		<div class="w1500 rel detail_nr br-10 mt-30 bj-0 pt-45 pb-45 pl-60 pr-60" style="">
			<div class="tit-30 B-700 ys-33 montserMedium">{{tzshu.title}}</div>
			<div class="flex a-center B-100 mt-26">
				<!-- <el-image fit="contain" class="" :src="require('@/assets/pc/detail1.png')" alt="" /> -->
				<!-- <el-image fit="contain" class="" :src="'http://goodwe.jsydl.com.cn:9200/'+tzshu.avatar" alt="" /> -->
				<div class="tit-18" style="width:30px;height: 30px;text-align: center;line-height: 30px;color: white;border-radius: 50%; flex-shrink: 0;"
					:style="getRandomGradient2(tzshu)">{{avatarText}}</div>
				<div class="tit-16 ys-77 ml-10 montserLight"> <span>{{gudingziduan.forum.By}} {{getProcessedNickname(tzshu.nickName?tzshu.nickName:tzshu.goodweId)}}</span> <el-divider
						direction="vertical"></el-divider>
						 <!-- <span>Total amount of reward:{{tzshu.integral}}</span> -->
					<el-divider direction="vertical"></el-divider> <span>{{gudingziduan.forum.Created}} {{tzshu.createTime}}</span><el-divider
						direction="vertical"></el-divider> <span>{{gudingziduan.forum.Lastreply}} {{tzshu.latestReplyTime}}</span>
				</div>
				<el-image v-if="tzshu.rewardPrice>0" fit="contain" class="ml-9" style="width: .2rem;height: .2rem;" :src="require('@/assets/xuanshan.png')" alt="" />
			</div>
			<el-divider class="mt-30 mb-44"></el-divider>
			<div class="mb-58 tit-16 ner ys-33 montserLight tneirong huifuneirongbox" v-html="tzshu.content">
			</div>
			<div class="flex flex-wrap">
				<div class="flex mr-37 a-center tit-15 ys-9a mb-10 cur_pointer" v-for="l in tzshu.attachments"
					v-if="tzshu.attachments" @click="chakanlianjie(l.url)">
					<i class="iconfont icon-wenjianlianjie mr-10 tit-24 montserLight" v-if="l.name"></i>
					{{l.name}}
				</div>
			</div>
			<el-divider class="mt-27 mb-35"></el-divider>
			<div class="w100 flex j-between fanye">
				<div class="fypage fypage1">
					<el-button type="primary" class="ys-33 hover_h cur_pointer" round icon="el-icon-arrow-left"
						@click="shangye()">{{gudingziduan.forum.previous}}</el-button>
					<i class="tit-14 ml-10 montserLight" style="color:#9C9C9C;">
						<!-- <span class="line1" v-if="tieindex > 0 && tieindex <= tiezilie.length && tiezilie[tieindex - 1]">  
							{{tiezilie[tieindex-1].theme}}
						</span> -->
						<span class="line1"
							v-if="tzshu.previousInvitation && tzshu.previousInvitation.theme">{{tzshu.previousInvitation.theme}}</span>
					</i>
				</div>
				<div class="fypage fypage2">
					<i class="tit-14 mr-10 montserLight" style="color:#9C9C9C;">
						<!-- <span class="line1"  v-if="tieindex + 1 < tiezilie.length && tiezilie[tieindex + 1].theme"> 
							{{tiezilie[tieindex+1].theme}}
						</span> -->
						<span class="line1"
							v-if="tzshu.nextInvitation && tzshu.nextInvitation.theme">{{tzshu.nextInvitation.theme}}</span>
					</i>
					<el-button type="primary" class="ys-33 hover_h cur_pointer" round @click="xiaye()">{{gudingziduan.forum.next}}<i
							class="el-icon-arrow-right el-icon--right"></i></el-button>
				</div>

			</div>
			<div class="abs youbian t-center w6">
				<div class="youge ys-33 flex column a-center cur_pointer" @click="caozuo(5)">
					<div class="youtub mb-10 br-50 flex a-center j-center"
						:class="tzshu.isLike ? 'bj-E6 ys-0' : 'bj-0'">
						<span class="tit-26 iconfont icon-dianzan11"></span>
					</div>
					<div class="tit-16 ">{{gudingziduan.forum.like}}({{tzshu.thumbsUpNum}}) </div>
				</div>
				<div class="youge ys-33 flex column a-center cur_pointer mt-80" @click="caozuo(6)">
					<div class="youtub mb-10 br-50 flex a-center j-center"
						:class="tzshu.isCollect ? 'bj-E6 ys-0' : 'bj-0'">
						<span class="tit-26 iconfont icon-shoucang"></span>
					</div>
					<div class="tit-16 ">{{gudingziduan.forum.favorite}}({{tzshu.collectNum}}) </div>
				</div>
				<div class="youge ys-33 flex column a-center cur_pointer mt-80" @click="dashang">
					<div class="youtub mb-10 br-50 flex a-center j-center"
						:class="zhuangtai.zt3 ? 'bj-E6 ys-0' : 'bj-0'">
						<span class="tit-26 iconfont icon-dashang"></span>
					</div>
					<div class="tit-16 ">{{gudingziduan.forum.Reward}}</div>
				</div>
			</div>
		</div>
		<!-- </div> -->
		<div class="w1500 detail_nr br-10 mt-30 bj-0 pt-45 pl-60 pr-60">
			<Bianjiqi v-model="shu.Content" ming="bianjiqiContent" yangshi="" gao="10"></Bianjiqi>
			<div class="w100 t-center anniu pb-49 mt-30 cur_pointer" @click='Fabu()'>
				<el-button type="primary" class="montserRegular tit-18">{{gudingziduan.forum.Comment}}</el-button>
			</div>
		</div>
		<!-- 打赏弹框 -->
		<div class="Reward_kuan1" v-if="dashanx">
			<div class="Reward_kuan2">
				<div class="Reward_kuan2_1">
					<div class="Reward_kuan2_1_1 flex j-between">
						<div class="tit-26">{{gudingziduan.forum.Reward}}</div>
						<div class="iconfont icon-guanbi f-40 cur_pointer" @click="guanbidas"></div>
					</div>
					<div class="Reward_kuan2_1_1 flex pt-20 pb-20">
						<div class="tit-20">{{gudingziduan.forum.CurrentPoints}}：{{myshux.pointNum}}</div>
						<div class="jifencounter ">
							<div @click="decrement"><i class="el-icon-remove-outline tit-20 cur_pointer"></i></div>
							<input type="number" v-model="dashangjifeng" readonly class="jifencount-input" />
							<div @click="increment"><i class="el-icon-circle-plus-outline tit-20 cur_pointer"></i></div>
						</div>
					</div>
					<div class="Reward_kuan2_1_1 pt-20 pb-20">
						<div class="tit-20">{{gudingziduan.forum.Ifyou}}</div>
					</div>
					<div class="mt-60 flex j-around">
						<div class="Rewardanniu3 pl-70 pr-70 pt-16 pb-16 cur_pointer" @click="guanbidas">Cancel</div>
						<div class="Rewardanniu pl-70 pr-70 pt-16 pb-16 cur_pointer ys-0 more1 wow fadeInUp montserLight"
							@click="Dashangs()">Submit</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 打赏弹框 -->
		<div class="w1500 mt-30 pinglunqu bj-0 pl-40 pr-40 br-10" ref="pinglunbox">
			<div class="pt-52 pb-52 tit-24">{{gudingziduan.forum.AllComment}} </div> 

			<div class="pinglun_lie pinglunqunrbox" >
				<!-- 一级评论 -->
				<div v-for="(item, index) in comments" :key="index" class="item" :ref="'pinglunbox_'+index">
					<div class="first flex">
						<!-- <el-image class="br-50" fit="cover"
							src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg" />
						 -->
						<div  v-if="item.user" class="tit-18 flex a-center j-center"
							style="width: .25rem; height: .25rem; min-width:30px;min-height: 30px;text-align: center;color: white;border-radius: 50%; flex-shrink: 0;"
							:style="item.userId ? getRandomGradient2(item) : {}">
						<!-- 	{{getFirstLetter(item.user)}} -->
						{{getFirstLetter(item.user)}}
					
						</div>
						<div  v-else class="tit-18 flex a-center j-center"
							style="width: .25rem; height: .25rem; min-width:30px;min-height: 30px;text-align: center;color: white;border-radius: 50%; flex-shrink: 0;"
							:style="item.userId ? getRandomGradient2(item) : {}">
						<!-- 	{{getFirstLetter(item.user)}} -->
							{{getFirstLetter(item.email)}}
						</div>
						<div class="first-content ml-21 flex1">
							<div class="w100 mb-10 ">
								<div class="flex flex-wrap j-between mb-10 w100">
									<div class="flex a-center flex-wrap">
										<div class="tit-16 ys-66">
											<i v-if="item.user">{{getProcessedNickname(item.user)}}</i>
											<i v-else-if="item.email">{{getProcessedNickname(item.email)}}</i>
											</div>
										<el-tag size="small" class="br-10  ml-13 mr-7 mingpai" style=""
											type="danger" color="#FCE4E6">
												<i v-if="item.roleIdentification">{{item.roleIdentification}}</i>
												<i v-else>{{item.roleName}}</i>
											</el-tag>

										<!-- <div class="tit-13 ys-c0">Total amount of reward: 0</div> -->
									</div>
									<div class="tit-15 ys-9">{{gudingziduan.forum.Created}} {{item.createTime}}</div>
								</div>
								<div class="tit-15 mb-22 montserLight w100 huifuneirongbox" v-html="item.content"></div>
								<div class="flex j-between">
									<div class="flex a-center info">
										<div class="cur_pointer flex a-center mr-55 num" @click="caozuo(1, index)">
											<i class="iconfont icon-dianzan_kuai mr-4 tit-16 "
												:class="item.isLike ? 'z-FF071C' : ''"></i>
											<div :class="item.isLike ? 'z-FF071C' : ''" class="tit-14 ys-77">{{gudingziduan.forum.like}}(<span
													v-if="item.likeNum>=0">{{ item.likeNum }}</span>)</div>
										</div>
										<div class="cur_pointer flex a-center mr-55 num"
											@click="toggleReply(item,index)">
											<i class="iconfont icon-pinglun2 mr-4 tit-16 "
												:class="caozuoindex == 2 && caozuoindex2 == index ? 'z-FF071C' : ''"></i>
											<div :class="caozuoindex == 2 && caozuoindex2 == index ? 'z-FF071C' : ''"
												class="tit-14 ys-77">Reply(<span
													v-if="item.responses &&  item.responses.length>=0">{{
													 item.responses.length }}</span>)</div>
										</div>
									<!-- 	shanchupinlun
										yincanpinlun
										zhidingpinlun -->
										<div v-if="guanliyuanindex==true" style="position: relative;" class="cur_pointer flex a-center mr-55 num" @click="guanliyuancaozuo(index)">
											<i class="iconfont icon-gengduo mr-4 tit-16 " :class="item.guanli==true ? 'z-FF071C' : ''"></i>
											<!-- <div class="tit-14 ys-77">{{gudingziduan.forum.shanchupinlun}}</div> -->
											<div v-if="item.guanli" class="br-2" style="position: absolute;z-index:22;bottom:9px;left:.28rem;background:#fff;;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
												<div v-if="guanliyuan.commentTop==true" @click="guanliyuancaozuo2(item,1)" style="padding:0 0.04rem;text-align: center;border-bottom: 1px #ebebeb solid;height: .45rem;line-height: .45rem;color:#333;">
														<i v-if="item.isTop==false">Pin</i>
														<i v-if="item.isTop==true">Unpin</i>
												</div>
												<div v-if="guanliyuan.deletedComment==true" @click="guanliyuancaozuo2(item,2)"  style="padding:0 0.40rem;text-align: center;border-bottom: 1px #ebebeb solid;height: .45rem;line-height: .45rem;color:#333;">Delete</div>
												<div v-if="guanliyuan.hideComment==true" @click="guanliyuancaozuo2(item,3)"  style="padding:0 0.4rem;text-align: center;height: .45rem;line-height: .45rem;color:#333;">hide</div>
											</div>
										</div>
								<!-- 		<div class="cur_pointer flex a-center mr-55 num" @click="guanliyuancaozuo(2, index)">
											<i class="iconfont icon-suo mr-4 tit-16 "></i>
											<div class="tit-14 ys-77">{{gudingziduan.forum.yincanpinlun}}</div>
										</div>
										<div class="cur_pointer flex a-center mr-55 num" @click="guanliyuancaozuo(3, index)">
											<i class="iconfont icon-zuihuo mr-4 tit-16 "></i>
											<div class="tit-14 ys-77">{{gudingziduan.forum.zhidingpinlun}}</div>
										</div> -->
										<!-- 	<div class="cur_pointer flex a-center mr-55 num">
											<i class="iconfont icon-dashang mr-4 tit-16 "
												:class="caozuoindex == 3 && caozuoindex2 == index ? 'z-FF071C' : ''"></i>
											<div :class="caozuoindex == 3 && caozuoindex2 == index ? 'z-FF071C' : ''"
												class="tit-14 ys-77">Reward(<span v-if="item.rewardNum>=0">{{
													item.rewardNum }}</span>)</div>
										</div> -->
									</div>
									<div class="flex a-center moreInfo">
										<div class="cur_pointer flex a-center mr-55" @click="shouqi(index)"
											v-if="item.isShow == true &&  item.responses.length>0">
											<i class="iconfont f-12 ys-97 icon-jiantou25 mr-13"></i>
											<div class="tit-14 ys-d5">{{gudingziduan.forum.retract}}(<span
													>{{ item.responses.length}}</span>)
											</div>
										</div>
										<div class="cur_pointer flex a-center mr-55" @click="zhankai(index)"
											v-if="item.isShow == false && item.responses.length>0">
											<i class="iconfont f-12 ys-97 icon-jiantou25 mr-13"
												style="transform: rotate(180deg);"></i>
											<div class="tit-14 ys-d5">{{gudingziduan.forum.more}}</div>
										</div>
									</div>
								</div>
								<!-- 回复评论下拉弹框 -->
								<transition name="fade">
									<div v-if="showReply[item.id]" class=" detail_nr reply-box pt-30 pb-30 pl-30 pr-30">
										<textarea :autosize="{minRows: 2, maxRows: 6}" placeholder="Type your reply..."
											v-model="pinglunhuifu" ></textarea>
										<div class="w100 t-right anniu mt-35 cur_pointer" @click='Fabu(item,index)'>
											<el-button type="primary" class="montserRegular tit-18">{{gudingziduan.forum.Comment}}</el-button>
										</div>
									</div>
								</transition>
								<!-- 回复评论下拉弹框 -->
								<div></div>
							</div>
							<div v-if="item.responses && item.responses.length>0"
								:style="'height: ' + (height[index] ? height[index] : '0') + ';overflow: hidden;transition: all 0.6s;'">
								<div class="bj-1 p-30 br-15" :ref="`myElement${index}`">
									<div v-for="(sons, sons_index) in item.responses" :key="sons_index">
										<div class="flex j-between mb-10 w100 flex-wrap">
											<div class="flex a-center flex-wrap">
												<!-- {{colorzu1 && wuserid == sons.userId?'111':colorzu1 && sons.userId==tzshu.userId?'222':'333'}} -->
												<div class="tit-18" v-if="sons.user"
													style="width:30px;height: 30px;text-align: center;line-height: 30px;color: white;border-radius: 50%;"
													:style="getRandomGradient2(sons)">
													{{getFirstLetter(sons.user)}}
												</div>
												<div v-else class="tit-18" 
													style="width:30px;height: 30px;text-align: center;line-height: 30px;color: white;border-radius: 50%;"
													:style="getRandomGradient2(sons)">
													{{getFirstLetter(sons.email)}}
												</div>
												<div class="tit-16 ys-66 ">
													<i v-if="sons.user">{{getProcessedNickname(sons.user)}}</i>
													<i v-else-if="sons.email">{{getProcessedNickname(sons.email)}}</i>
									<!-- 			{{getProcessedNickname(sons.user)  }} -->
												</div>
												<el-tag size="small" class="br-10 f-12 ml-13 mr-7"
													style="color: #ff0000;" type="danger" color="#FCE4E6">SEMS</el-tag>

												<!-- <div class="tit-13 ys-c0">Total amount of reward: 0</div> -->
											</div>
											<div class="tit-15 ys-9">{{gudingziduan.forum.Created}} {{sons.createTime}}</div>
										</div>
										<div class="tit-15 mb-22 montserLight huifuneirongbox"  v-html="sons.content">
										</div>
										<div class="flex a-center info">
											<div class="flex a-center mr-55 num">
												<i class="iconfont icon-dianzan_kuai mr-4 tit-16"></i>
												<div class="tit-14 ys-77">
													{{gudingziduan.forum.like}}(<span v-if="sons.likeNum>=0">{{ sons.likeNum }}</span>)</div>
											</div>
											<!-- <div class="flex a-center mr-55 num">
												<i class="iconfont icon-pinglun2 mr-4 tit-16"></i>
												<div class="tit-14 ys-77">
													Reply(<span v-if="sons.Reply>=0">{{ sons.userNum }}</span>)</div>
											</div> -->
											<!-- 	<div class="flex a-center mr-55 num">
												<i class="iconfont icon-dashang mr-4 tit-16"></i>
												<div class="tit-14 ys-77">
													Reward(<span v-if="sons.Reward>=0">{{ sons.rewardNum }}</span>)
												</div>
											</div> -->
										</div>
										<el-divider v-if="item.responses.length != sons_index + 1"
											class="mt-30 mb-44"></el-divider>
									</div>

								</div>
							</div>

						</div>
					</div>
					<el-divider class="mt-30 mb-44"></el-divider>
				</div>
			</div>
		</div>
		<el-pagination class="flex j-center pb-108" @size-change="handleSizeChange"
			@current-change="handleCurrentChange" :current-page.sync="sos.ye" :page-size="sos.jitiao"
			layout="prev, pager, next, jumper,slot" :total="zongshu">
			<span class="ml-10 cur_pointer" @click="goToPage">go</span>
		</el-pagination>
		<el-dialog width="90%" :visible.sync="showImageDialog" title="" >
			<el-image :src="currentImage" :preview-src-list="[currentImage]"></el-image>
		</el-dialog>
		<Foot></Foot>
	</div>

</template>

<script>
	import Tou from '../../../zuzuzu/touss.vue'
	import Bianjiqi from '../../../zujian/wangEditor.vue'
	import Foot from '../../../zuzuzu/foot.vue'
	import {allUser,Guangliyuan} from '@/api/user.js';
	import {
		detailsxq,
		detailscomments,
		fabucomment,
		pinglundianzan,
		tiezidianzan,
		tiezishoucang,
		tielie,
		tiezidashang,
		guanliplzhiding,
		guanliplshanchu,
		guanliplyingcan
	} from '@/api/formdetails.js';
	export default {
		data() {
			return {
				zhuangtai: {
					zt1: false,
					zt2: false,
					zt3: false
				},
				wuserid:'',
				colorzu:[],
				colorzu1:'',
				colorzu3:'',
				colorzu2:[],
				dashanx: false,
				shu: {},
				comments: [
				],
				sos: {
					jitiao: 6,
					ye: 0
				},
				zongshu: 60,
				targetPage: '',
				height: [],
				caozuoindex: -1,
				caozuoindex2: -1,
				xihuan: false,
				tzid: '',
				tzshu: {
					// theme: 'Goodwee Homekit 3000',
					// createTime: 'Created 2024-10-16',
					// content: 'Goodwee HomekitGoodwee HomekitGoodwee Homekit',
					// thumbsUpNum: '1',
					// collectNum: '2'
				},
				showReply: {}, // 用于存储父评论的回复框显示状态  
				showSubReply: {}, // 用于存储子评论的回复框显示状态  \
				pinglunhuifu: '',
				tiezilie: [],
				tieindex: 0,
				gerenxinxi:{},
				denglu: false,
				myshux:{},
				dashangjifeng: 0,
				gradients: [
					['#FDEB71', '#F8D800'],
					['#ABDCFF', '#0396FF'],
					['#FEB692', '#EA5455'],
					['#CE9FFC', '#7367F0'],
					['#90F7EC', '#32CBCB'],
					['#FFF6B7', '#F6416C'],
					['#81FBB8', '#28C76F'],
					['#E2B0FF', '#9F44D3'],
					['#F97794', '#623AA2'],
					['#FCCF31', '#F55555'],
					['#F761A1', '#8C1BAB'],
					['#43CBFF', '#9708CC'],
					['#5EFCE8', '#736EFE'],
					['#FAD7A1', '#E96D71'],
					['#FFD26F', '#3677FF'],
					['#A0FE65', '#FA016D'],
					['#FFDB01', '#0E197D'],
					['#FEC163', '#DE4313'],
					['#92FFC0', '#002661'],
					['#EEAD92', '#6018DC'],
					['#F6CEEC', '#D939CD'],
					['#52E5E7', '#130CB7'],
					['#F1CA74', '#A64DB6'],
					['#E8D07A', '#5312D6'],
					['#EECE13', '#B210FF'],
					['#79F1A4', '#0E5CAD'],
					['#FDD819', '#E80505'],
					['#FFF3B0', '#CA26FF'],
					['#FFF5C3', '#9452A5'],
					['#F05F57', '#360940'],
					['#2AFADF', '#4C83FF'],
					['#FFF886', '#F072B6'],
					['#97ABFF', '#123597'],
					['#F5CBFF', '#C346C2'],
					['#FFF720', '#3CD500'],
					['#FF6FD8', '#3813C2'],
					['#EE9AE5', '#5961F9'],
					['#FFD3A5', '#FD6585'],
					['#C2FFD8', '#465EFB'],
					['#FD6585', '#0D25B9'],
					['#FD6E6A', '#FFC600'],
					['#65FDF0', '#1D6FA3'],
					['#6B73FF', '#000DFF'],
					['#FF7AF5', '#513162'],
					['#F0FF00', '#58CFFB'],
					['#FFE985', '#FA742B'],
					['#FFA6B7', '#1E2AD2'],
					['#FFAA85', '#B3315F'],
					['#72EDF2', '#5151E5'],
					['#FF9D6C', '#BB4E75'],
					['#F6D242', '#FF52E5'],
					['#69FF97', '#00E4FF'],
					['#3B2667', '#BC78EC'],
					['#70F570', '#49C628'],
					['#3C8CE7', '#00EAFF'],
					['#FAB2FF', '#1904E5'],
					['#81FFEF', '#F067B4'],
					['#FFA8A8', '#FCFF00'],
					['#FFCF71', '#2376DD'],
					['#FF96F9', '#C32BAC'],
					// 这里可以添加更多的颜色组合  
				],
				colorCache:{},
				gudingziduan: {},
				showImageDialog:false,
				currentImage:'',
				guanliyuan:{},
				guanliyuanindex:false,
				guanliyuanindex3:false
			
			}
		},
		components: {
			Tou,
			Bianjiqi,
			Foot
		},
		watch: {
		    '$store.state.cunyuanyan': {
		      handler(newValue, oldValue) {
		        // console.log('语言已更新:', newValue);
		        this.gudingziduan=this.$store.state.cunyuanyan
				// console.log(this.gudingziduan,'video')
		      },
		      deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
		    }
		},
		created() {
			// this.tzid = this.$route.query.id;
			this.tzid = this.$route.params.id;
			// <!-- 改跳转链接 -->
			this.tiezhixiangqing()
			this.pinglun(-1)
			this.wuserid=this.$qu('guserid')
			this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
			this.gudingziduan=this.$store.state.cunyuanyan
			// console.log(this.gudingziduan,'details ')
			// this.colorzu=this.$qu('userColors')
			this.colorzu1=this.$qu('uColor2_'+this.wuserid)
			if(this.colorzu1.length>0){
				this.colorzu=this.colorzu1.split(',');
			}
			if(!this.$qu('kouling')){
				allUser().then(s=>{
					if(s.code!=200){
						
					}
				})
			}
			Guangliyuan().then(s=>{
				if(s.code==200){
					this.guanliyuan=s.data
					this.guanliyuanindex=true
				}
			})
		},
		computed: {
			avatarText() {
				// 提取首字或首字母  tzshu.nickName?tzshu.nickName:tzshu.goodweId
				return this.tzshu.nickName 
				  ? this.tzshu.nickName.charAt(0).toUpperCase() 
				  : this.tzshu.goodweId 
				    ? this.tzshu.goodweId.charAt(0).toUpperCase() 
				    : '?';
			},
			avatarStyle() {
				return {
					background: this.getRandomGradient(),
				}
			},
			// avatarStyle2() {
			// 	return {
			// 		background: this.getRandomGradient(),
			// 	}
			// },
			avatarStyle3() {
				return {
					background: this.getRandomGradient(),
				}
			}
		},
		mounted() {
			if (this.comments[0] && this.comments[0].isShow == true) {
				// this.$nextTick(() => {
				this.$set(this.height, 0, this.$refs[`myElement${0}`][0].offsetHeight + 'px')
				// });
			}
			if(this.$qu('yonghuming').length==0 && this.$qu('kouling').length==0){
				this.denglu = false
			}else {
				this.denglu = true
			}
		},
		methods: {
			chakanlianjie(e){
				window.open(e, '_blank');
			},
			//打赏积分
			increment() {
				if(this.dashangjifeng<this.myshux.pointNum){
					this.dashangjifeng++;
				}
			},
			decrement() {
				if (this.dashangjifeng > 0) {
					this.dashangjifeng--;
				}
			},
			guanbidas(){
				this.dashanx=false
			},
			Dashangs(e){
				var dsshu={}
				// type为 1对应帖子id，为2是对应评论id
				// if(e){
				// 	dsshu.id=e.id
				// 	dsshu.type=2
				// }else{
					dsshu.id=this.tzshu.userId
					dsshu.type=1
				// }
				// console.log(this.dashangjifeng,1)
				if(this.dashangjifeng<=0){
					this.$message({
					  showClose: true,
					  message:'Points cannot be zero',
					  type: 'error',
					  offset:'350',
					  duration:0
					});
					this.dashanx=false
				}else{
					dsshu.invitationId=this.tzshu.id
					dsshu.num=this.dashangjifeng
					tiezidashang(dsshu).then(shu=>{
						// this.$message(shu.message);
						if(shu.code==200){
							this.dashanx=false
							this.$message({
							  showClose: true,
							  message:shu.message,
							  type: 'success',
							  offset:'350',
							  duration:2000
							});
						}
						this.tiezhixiangqing()
					})
				}
			},
			// 发布评论
			Fabu(e,i) {
				if(this.denglu) {
					const pinlunshu = {}
					pinlunshu.invitationId = this.tzid;
					pinlunshu.replyUserId = '';
					// console.log(e)
					if (e && e.id) {
						pinlunshu.content = this.pinglunhuifu;
						pinlunshu.replyUserId = e.userId;
						pinlunshu.pid = e.id;
					} else {
						pinlunshu.content = this.shu.Content;
						pinlunshu.pid = null;
						pinlunshu.replyUserId = this.tzshu.userId;
					}
					pinlunshu.persons = '';
					// console.log(pinlunshu)
					fabucomment(pinlunshu).then(shu => {
						if (shu.result == 'SUCCESS') {
							// this.$xiaoxi(shu.message)
							// this.$message(shu.message);
							this.shu.Content=''
							this.pinglunhuifu=''
							this.$message({
							  showClose: true,
							  message:shu.message,
							  type: 'success',
							  offset:'350',
							  duration:2000
							});
							this.tiezhixiangqing()
							
							this.sos.ye=0
							if(e){
								if(e.id){
									this.$set(this.showReply, e.id, !this.showReply[e.id]);
								}
							  this.zhankai(i)
							  this.pinglun(e,i)
							}else{
								this.pinglun()
							}
							// location.reload();
						}else{
							this.$message({
							  showClose: true,
							  message:shu.message,
							  type: 'error',
							  offset:'350',
							  duration:2000
							});
						}
					})
				}else {
					 this.$alert('Please log in first', '', {
					  confirmButtonText: 'Log in',
					  confirmButtonClass:'Loginanniu',
					  distinguishCancelAndClose:true,
					  center:true,
					  roundButton:true,
					  callback: action => {
						  if(action=='confirm'){
								this.$dakai('/login_in')
						  }
					  }
					});
					// this.$message({
					//   showClose: true,
					//   iconClass:'el-icon-warning',
					//   customClass:'my-error-message',
					//   dangerouslyUseHTMLString: true,
					//   message:'<strong><i style="margin-left:.1rem;">Please log in first</i> <a href="https://community.goodwe.com/login_in" style="color:red;margin-left:4px;text-decoration: none;">[here]</i> </strong>',
					//   type: 'error',
					//   offset:'350',
					//   duration:0
					// });
				}
			},
			toggleReply(e, indexs) {
				const commentId = e.id;
				this.$set(this.showReply, commentId, !this.showReply[commentId]);
				// console.log(this.showReply)
			},
			handleCurrentChange(e) {
				this.sos.ye=e
				console.log(e)
				this.pinglun(e-1)
			},
			handleSizeChange(e) {},
			goToPage() {
				this.handleCurrentChange(this.sos.ye)
			},
			pinglun(e,i) { //分页查看评论
			var yes=0
			var that=this
			if(that.sos.ye>0){
				yes=that.sos.ye-1
			}else{
				yes=that.sos.ye
			}
				detailscomments({
					'invitationId': that.tzid,
					'pid': null,
					'pageNum':yes,
					'pageSize': that.sos.jitiao,
					"userId": that.tzshu.userId
				}).then(shu => { //分页查看帖子评论
					that.comments = shu.data.content
					that.zongshu = Number(shu.data.totalElements)
					that.comments=that.comments.map(comment => {
						const newContent=comment.content.replace(/<img.*?src="([^"]+)"/g, (match, p1) => {
						const src = p1.startsWith('http') ? p1 : '' + p1;
						const container = document.querySelector('.comment-container');
						// 创建一个包含点击事件的图片标签
						// return `<img 
						// 	 src="${src}" 
						// 	 style="cursor: pointer; max-width: 100%;" 
						// 	 onclick="shouimgs('${src}')"
						//    `;
						return `<img src="${src}" style="cursor: pointer; max-width: 100%;" data-src="${src}"`
						 // return `<img 
						 // src="${p1}" 
						 // style="cursor: pointer; max-width: 100%;" 
						 // @click="shouimgs('${p1}')"`;
						// 	if (!p1.startsWith('http')) {
						// 		return match.replace(p1, '' + p1);
						// 	}
						// 	return match;
						});
						 return {
						  ...comment,
						  content: newContent
						};
					});
					 that.$nextTick(() => {
						const imgs = document.querySelectorAll('img');
						imgs.forEach(img => {
							img.addEventListener('click', () => {
								that.shouimgs(img.dataset.src);
							});
						});
					});

					if(e && e!=-1){
						const pinglunboxIndex = that.comments.indexOf(e);
						const pinglunbox = that.$refs['pinglunbox_' + pinglunboxIndex][0];
						 if (pinglunbox) {
							pinglunbox.scrollIntoView({ behavior:'smooth' });
						 }
						 
					}else{
						 if(e!=-1){
							const draftBox = that.$refs.pinglunbox;
							if (draftBox) {
								draftBox.scrollIntoView({ behavior:'smooth' });
							}
						 }
					}
				})
			},
			shouimgs(e){
				console.log(e,11111)
				this.showImageDialog=true;
				this.currentImage=e
			},
			shangye() {
				// if (this.tieindex > 0) {  
				// 	this.tieindex--;  
				// this.tzid=this.tiezilie[this.tieindex].id
				this.tzid = this.tzshu.previousInvitation.id
				this.tiezhixiangqing()
				// }
			},
			xiaye() {
				// if (this.tieindex < this.tiezilie.length - 1) {  
				// this.tieindex++;
				// this.tzid=this.tiezilie[this.tieindex].id
				this.tzid = this.tzshu.nextInvitation.id
				this.tiezhixiangqing()
				// }  
			},
			// 相同组类型帖子
			// Xtieliw(e){
			// 	tielie({'gid':e,'ye':0,'jitiao':10}).then(shu=>{
			// 		this.tiezilie=shu.data.content
			// 		this.tieindex =this.tiezilie.findIndex(post => post.id ===this.tzshu.id);
			// 		// console.log(this.tieindex+'测呃呃呃')
			// 	})
			// },
			tiezhixiangqing() {
				detailsxq(this.tzid).then(shu => { //帖子详情
					const prefix = "https://community.goodwe.com ";
					this.tzshu = shu.data
					// this.tzshu.nickName=this.getProcessedNickname(this.tzshu.nickName)
					this.colorzu3=this.$qu('uColor2_'+this.tzshu.userId)
					// console.log(this.colorzu3)
					if(this.colorzu3.length>0){
						this.colorzu2=this.colorzu3.split(',');
					}
					// this.zongshu = shu.data.commentNum

					this.tzshu.attachments = this.tzshu.attachments.split(',').map(file => {
						const trimmedPath = file.trim();
						const fileName = trimmedPath.split('/').pop(); // 提取文件名  
						return {
							// url: prefix + trimmedPath,
							url: trimmedPath,
							name: fileName
						};
					});
					// console.log(this.tzshu.attachments)
					// this.Xtieliw(this.tzshu.groupId)
				})
			},
			hoverItem(index) {
				// 更新hoverStates对象中对应索引的hover状态  
				setTimeout(() => {
					this.hoverStates = this.resoulie[index].tu
				}, 600)
				// this.$set(this.hoverStates, this.resoulie[index].tu); // 使用$set确保响应性  

			},
			zhankai(i) {
				this.comments[i].isShow = true
				this.$nextTick(() => {
					this.$set(this.height, i, this.$refs[`myElement${i}`][0].offsetHeight + 'px')
				});
			},
			shouqi(i) {
				this.comments[i].isShow = false
				this.$set(this.height, i, 0)
			},
			likai() {
				this.leiming = 'likai'
				setTimeout(() => {
					this.leiming = ''
				}, 600)
			},
			getHoverImage(index) {
				// 根据hover状态返回相应的图片路径  
				return this.hoverStates[index] ? this.list[index].hoverImg : this.list[index].img;
			},
			guanliyuancaozuo(i){
				console.log(this.comments[i])
				if(!this.comments[i].guanli){
					this.$set(this.comments[i], 'guanli', false)
				}
				if (this.comments[i].guanli == true) {
					this.$set(this.comments[i], 'guanli', false)
				}else{
					this.$set(this.comments[i], 'guanli', true)
				}
				
			},
			guanliyuancaozuo2(e,i){
				if(i==1 && this.guanliyuan.commentTop==true){
					// var available=true
					// if(e.isTop==true){
					// 	available=false
					// }
					e.isTop=!e.isTop
					guanliplzhiding({'id':e.id,'available':e.isTop}).then(s=>{
						this.$message({
						  showClose: true,
						  message:s.message,
						  type: 'success',
						  offset:'350',
						  duration:2000
						});
						this.pinglun()
						// this.$set(e, 'guanli', false)
					})
					
				}else if(i==2 && this.guanliyuan.deletedComment==true){
					guanliplshanchu({'id':e.id}).then(s=>{
						this.$message({
						  showClose: true,
						  message:s.message,
						  type: 'success',
						  offset:'350',
						  duration:2000
						});
						this.pinglun()
						// this.$set(e, 'guanli', false)
					})
				}else if(i==3 && this.guanliyuan.hideComment==true){
					// e.isShow=!e.isShow
					guanliplyingcan({'id':e.id,'available':false}).then(s=>{
						this.$message({
						  showClose: true,
						  message:s.message,
						  type: 'success',
						  offset:'350',
						  duration:2000
						});
						this.pinglun()
					})
				}
				this.$set(e, 'guanli', false)
			},
			caozuo(e, i) {
				if(this.denglu) {
					this.caozuoindex = e
					this.caozuoindex2 = i
					let pingluntype = ''
					let shoucantype = ''
					let dianzantype = ''
					if (e == 1) {
						if (this.comments[i].isLike == true) {
							console.log(111)
							this.$set(this.comments[i], 'Like', this.comments[i].Like - 1)
							this.$set(this.comments[i], 'Likezt', false)
							this.$set(this.comments[i], 'isLike', false)
							pingluntype = 'thumbsUp'
						} else {
							this.$set(this.comments[i], 'Likezt', true)
							this.$set(this.comments[i], 'Like', this.comments[i].Like + 1)
							this.$set(this.comments[i], 'isLike', true)
							console.log(222)
							pingluntype = 'thumbsUp'
						}
						console.log(this.comments[i].isLike)
						pinglundianzan({
							'avaliable': this.comments[i].isLike,
							'invitationId': this.comments[i].id,
							'type': pingluntype
						}).then(shu => {
							// this.$message(shu.message);
							this.$message({
							  showClose: true,
							  message:shu.message,
							  type: 'success',
							  offset:'350',
							  duration:2000
							});
							this.pinglun()
							this.tiezhixiangqing()
							// location.reload();
						})
						// console.log(this.comments[i].Likezt)
					} else if (e == 2) {
						this.$set(this.comments[i], 'Reply', this.comments[i].Reply + 1)
					} else if (e == 3) {
						this.$set(this.comments[i], 'Reward', this.comments[i].Reward + 1)
					} else if (e == 5 || e == 6) {
						// 点赞帖子
						if (e == 5) {
							if (this.tzshu.isLike == true) {
								this.$set(this.tzshu, 'isLike', false)
								dianzantype = 'thumbsUp'
							} else if (this.tzshu.isLike == false) {
								this.$set(this.tzshu, 'isLike', true)
								dianzantype = 'thumbsUp'
							}
							// console.log(dianzantype)
							// console.log(this.tzshu)
							tiezidianzan({
								'avaliable': this.tzshu.isLike,
								'invitationId': this.tzshu.id,
								'type': dianzantype
							}).then(shu => {
								// this.$message(shu.message);
								this.$message({
								  showClose: true,
								  message:shu.message,
								  type: 'success',
								  offset:'350'
								});
								if (shu.code == 200) {
									this.tiezhixiangqing()
								}
							})
						} else {
							if (this.tzshu.isCollect == true) {
								this.$set(this.tzshu, 'isCollect', false)
								shoucantype = 'Collection'
							} else {
								this.$set(this.tzshu, 'isCollect', true)
								shoucantype = 'Collection'
							}
					
							tiezishoucang({
								'avaliable': this.tzshu.isCollect,
								'invitationId': this.tzshu.id,
								'type': shoucantype
							}).then(shu => {
								// this.$message(shu.message);
								this.$message({
								  showClose: true,
								  message:shu.message,
								  type: 'success',
								  offset:'350',
								  duration:2000
								});
								this.tiezhixiangqing()
							})
						}
					}
				}else {
					// this.$message({
					//   showClose: true,
					//   iconClass:'el-icon-warning',
					//   customClass:'my-error-message',
					//   dangerouslyUseHTMLString: true,
					//   message:'<strong><i style="margin-left:.1rem;">Please log in first</i> <a href="https://community.goodwe.com/login_in" style="color:red;margin-left:4px;text-decoration: none;">[here]</i> </strong>',
					//   type: 'error',
					//   offset:'350',
					//   duration:0
					// });
					this.$alert('Please log in first', '', {
					  confirmButtonText: 'Log in',
					  confirmButtonClass:'Loginanniu',
					  distinguishCancelAndClose:true,
					  center:true,
					  roundButton:true,
					  callback: action => {
						  if(action=='confirm'){
								this.$dakai('/login_in')
						  }
					  }
					});
				}
				
				// console.log(this.comments[i].Reward)
			},
			dashang() {
				if(this.denglu) {
					this.dashanx=true
				}else {
					this.$alert('Please log in first', '', {
					  confirmButtonText: 'Log in',
					  confirmButtonClass:'Loginanniu',
					  distinguishCancelAndClose:true,
					  center:true,
					  roundButton:true,
					  callback: action => {
						  if(action=='confirm'){
								this.$dakai('/login_in')
						  }
					  }
					});
					// this.$message({
					//   showClose: true,
					//   iconClass:'el-icon-warning',
					//   customClass:'my-error-message',
					//   dangerouslyUseHTMLString: true,
					//   message:'<strong><i style="margin-left:.1rem;">Please log in first</i> <a href="https://community.goodwe.com/login_in" style="color:red;margin-left:4px;text-decoration: none;">[here]</i> </strong>',
					//   type: 'error',
					//   offset:'350',
					//   duration:0
					// });
				}
			},

			getFirstLetter(name) {
				// return name.charAt(0).toUpperCase(); // 返回第一个字母并转换为大写  
				return name ? name.charAt(0).toUpperCase() : '?';
			},
			getProcessedNickname(e) {
				if(e){
				  const atIndex =e.indexOf('@');
				  if(atIndex){
					return atIndex!== -1? e.slice(0, atIndex) : e;
				  }
				}
			},
			getRandomGradient() {
				// 随机选择一个渐变组合  
				const randomGradient = this.gradients[Math.floor(Math.random() * this.gradients.length)];
				return `linear-gradient(135deg, ${randomGradient[0]}, ${randomGradient[1]})`;
			},
			getRandomGradient2(z) {
			  if (!z || !z.userId) {
				return { background: 'linear-gradient(135deg, #ccc, #ddd)' };
			  }
			
			  const userId = z.userId;
			  const key = `user-${userId}`; // 只用 userId 唯一标识
			 console.log(userId,'userId')
			  // 如果已缓存，则直接返回
			  if (this.colorCache[key]) {
				const cached = this.colorCache[key];
				if (Array.isArray(cached) && cached.length >= 2) {
				  return {
					background: `linear-gradient(135deg, ${cached[0]}, ${cached[1]})`
				  };
				}
			  }
			
			  // 使用哈希算法生成索引
			  const hash = this.hashString(key);
			  const index = hash % this.gradients.length;
			  const gradient = this.gradients[index];
			
			  // 确保有效
			  if (!Array.isArray(gradient) || gradient.length < 2) {
				gradient = this.gradients[0] || ['#ccc', '#ddd'];
			  }
			
			  // 缓存
			  this.colorCache[key] = gradient;
			
			  return {
				background: `linear-gradient(135deg, ${gradient[0]}, ${gradient[1]})`
			  };
			},
		// 简单哈希函数
		hashString(str) {
		  let hash = 0;
		  for (let i = 0; i < str.length; i++) {
		    hash = ((hash << 5) - hash) + str.charCodeAt(i);
		    hash = hash & hash; // Convert to 32bit integer
		  }
		  return Math.abs(hash);
		}
		}
	}
</script>

<style lang="scss">
	body {
		background-color: #f6f7f8 !important;

	}
	.huifuneirongbox i{ font-style:italic !important;}
	.detailbox .el-dialog{
		background: rgba(0, 0, 0, 0) !important;
		height: 80vh;
		.el-dialog__body{
			background: rgba(0, 0, 0, 0) !important;
			padding:0;
		}
		.el-dialog__header{
			background: #fff !important;
			padding-bottom: 30px;
		}
	}
	.mingpai{
		color: #ff0000 !important;font-size: .1rem !important;height:.2rem;line-height:.17rem;
	}
	.pinglunqunrbox img {max-width: 100%; height: auto !important;}
	// 打赏弹框
	.Reward_kuan1 {
		position: fixed;
		z-index: 9999;
		width: 100%;
		height: 100%;
		top: 0;
		background: rgba(0, 0, 0, 0.5);
		display: block;
	}

	.Reward_kuan2 {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;

		.Reward_kuan2_1 {
			background-color: #ffffff;
			border-radius: 20px;
			width: 38.6%;
			padding: 35px 48px 47px 48px;

			.Reward_kuan2_1_1 {
				border-bottom: 1px solid #e6e6e6;
				position: relative;
				padding-bottom: 7px
			}
		}

		.Rewardanniu {
			display: inline-block;
			background: linear-gradient(87deg, #ff785c 0%, #e70a16 100%);
			border-radius: 50px;
			margin: 0 auto;
		}

		.Rewardanniu3 {
			display: inline-block;
			border-radius: 50px;
			margin: 0 auto;
			border: solid 1px #e60012;
		}
		.jifencounter {  
		    display: flex;  
		    align-items: center;  
			margin-left: 17%;
		}  
		
		.jifencount-input {  
		    width: 50px;  
		    text-align: center;  
		    border: 1px solid #ccc;  
		    border-radius: 4px;  
		    margin: 0 10px;  
		    font-size: 16px;  
		}  
	}

	.w-e-text-container {
		height:100px !important;
	}

	.z-FF071C {
		color: #FF071C;
	}

	.bj-E6 {
		background: #E60012;
	}

	.detail {
		.youbian {
			right: 0;
			top: 8%;
			transform: translateX(130%);

			.youtub {
				width: .56rem;
				height: .56rem;
				min-height: 40px;
				min-width: 40px;
			}
		}



		.fanye.el-button:hover {
			background: linear-gradient(87deg, #ff785c 0%, #e70a16 100%) !important;
			color: #fff !important;
		}

		.fanye .fypage {
			display: flex;
			align-items: center;
			max-width: 48%;
		}

		.hover_h:hover {
			background: linear-gradient(87deg, #ff785c 0%, #e70a16 100%) !important;
			color: #fff !important;
		}

		.detail_nr {
			box-sizing: border-box;
			.el-image {
				width: 36px;
				flex-shrink: 0;
			}

			.ner {}

			.fanye .fypage .el-button {
				background: #EEEEEE;
				border-color: #EEEEEE;
				color: #333333;
				font-size: 14px;
				width: 94px;
				height: 34px;
				padding: 0;
				flex-shrink: 0;
			}

			.anniu .el-button {
				padding: .15rem .35rem;
				background: linear-gradient(87deg, #ff785c 0%, #e70a16 100%);
				border-radius: 100px;
				color: #fff;
				border-color: transparent;
			}

			.w-e-text-container {
				min-height:100px !important;
			}
		}

		.pinglunqu {
			box-sizing: border-box;
			.flex1 {
				flex: 1;
			}

			.pinglun_lie {
				.item .first {
					flex-wrap: wrap;
				}

				.el-image {
					width: .58rem;
					height: .58rem;
					flex-shrink: 0;
				}
			}
		}

	}

	//下拉回复框
	.reply-box {
		width: 96% !important;
		margin-top: 10px;
		transition: max-height 0.4s ease-in-out;
		/* 添加缓慢下拉效果 */
		max-height: 2000px;
		/* 控制下拉框最大高度 */
		overflow: hidden;
		/* 超出部分隐藏 */
		background-color: #f5f5f5;
		border-radius: 20px;
	}

	textarea {
		width: 100%;
		min-height: 100px;
		background-color: #f5f5f5;
		outline: none;
		resize: none;
		border: 0;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.3s;
	}

	.fade-enter,
	.fade-leave-to

	/* .fade-leave-active in <2.1.8 */
		{
		opacity: 0;
	}

	.tneirong img , .tneirong video , .tneirong iframe{
		max-width: 100% !important;
		height: auto !important;
	}

	// ==========================================================================================================================================================================
	// 响应式

	@media screen and (max-width: 1200px) {
		.detail_nr {
			width: 78%;
		}
		.pinglunqu {width: 78%;}
	}

	@media screen and (max-width: 767px) {
		.detail_nr {
			width: 95%;
			display: flex;
			flex-direction: column;
		}

		.detail .detail_nr .el-image {
			display: none;
		}

		.detail_nr .fanye {
			margin-top: .5rem;
			flex-wrap: wrap;
			order: 2;
		}

		.detail .fanye .fypage {
			max-width: 100%;
			margin: .15rem 0;
		}

		.detail .youbian {
			position: relative;
			display: flex;
			justify-content: space-between;
			width: 100%;
			transform: none;
		
		}

		.detail .youbian .youge {
			margin-top: 0;
		}

		.detail .youbian .youtub {
			background: #EEEEEE;
		}

		.detail .youbian .youtub.bj-E6 {
			background: #E60012;
		}

		.detail .pinglunqu .pinglun_lie .el-image {
			width: 1rem;
			height: 1rem;
		}

		.detail .pinglunqu .flex1 {
			margin-top: .3rem;
			width: 100%;
			flex: none;
			max-width: 100%;
			margin-left: 0;
		}

		.first-content .info {
			flex-wrap: wrap;
		}

		.first-content .info .num {
			margin-right: .2rem;
		}

		.first-content .info .num:last-child {
			margin-right: 0;
		}

		.first-content .moreInfo .mr-55 {
			margin-right: 0;
		}

		.pinglunqu {width: 95%;}
	}
</style>